module.exports = __webpack_public_path__ + "f47ba10424d3cb022507870189d9de75.svg";